import React, { useEffect, useState, useRef } from "react";
import {
  GetPaymentVoucherList,
  GetPaymentVoucherById,
  PaymentVoucherUpdate,
  PaymentVoucherCreate,
  PaymentVoucherDelete,
  GetApproveGVs,
  GetApprovedPVs,
  BankDetailList,
  ApproveAccountsPaymentVoucher,
  GeneratePaymentVoucherNo,
  ExpenseList,
} from "../../../Services/Services";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Modal,
  Box,
  TextField,
  MenuItem,
  Popover,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Checkbox,
  Autocomplete,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Divider,
  Collapse,
  Menu,
} from "@mui/material";
import {
  Edit,
  Delete,
  Print,
  Visibility,
  Add,
  Close,
} from "@mui/icons-material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"; // ⭐ ADD
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { useMediaQuery, useTheme } from "@mui/material";
import { Tooltip } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import AddIcon from "@mui/icons-material/Add";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { generatePaymentPdf } from "../Accounts/PaymentVoucherPrint";
import config from "../../../config";
import { Chip } from "@mui/material";
import { ToWords } from "to-words";

const PaymentVouchersBank = () => {
  // ===== States =====
  const [dateMenuAnchor, setDateMenuAnchor] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [selectingDate, setSelectingDate] = useState(null);
  const [dateRangeFilter, setDateRangeFilter] = useState("today");
  const [customDateRange, setCustomDateRange] = useState({ from: "", to: "" });
  const dateInputRef = useRef(null);
  // ⭐ ADD THIS NEW STATE (line ~47, after other states)
  const [showCustomDateInputs, setShowCustomDateInputs] = useState(false);
  const [tempCustomDateRange, setTempCustomDateRange] = useState({
    from: "",
    to: "",
  });
  const [PaymentVouchers, setPaymentVouchers] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [rowErrors, setRowErrors] = useState([]);
  const [rows, setRows] = useState([blankRow()]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editFormData, setEditFormData] = useState({});
  const [open, setOpen] = useState(false);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewData, setViewData] = useState({});
  const [purchaseVoucherData, setPurchaseVoucherData] = useState({});
  const [generalVoucherData, setGeneralVoucherData] = useState({});

  const [anchorEl, setAnchorEl] = useState(null);
  const [voucherToDelete, setVoucherToDelete] = useState(null);
  const [approveAnchorEl, setApproveAnchorEl] = useState(null);
  const [PaymentToApprove, setPaymentToApprove] = useState(null);
  const [remarkInput, setRemarkInput] = useState("");
  const [actionType, setActionType] = useState(null);
  const [showRemarkForIndentId, setShowRemarkForIndentId] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [filters, setFilters] = useState({
    payment_no: "",
    po_no: "",
    supplier: "",
    status: "Pending",
    payment_mode: "Bank", // ✅ Filter for Bank only
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [expandedVoucher, setExpandedVoucher] = useState(null);

  const [bankDetails, setBankDetails] = useState([]);

  // ===== Initial Data Fetch =====
  useEffect(() => {
    fetchAllData();
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      fetchVouchers(1, true, filters);
    }, 500);

    return () => clearTimeout(handler);
  }, [filters, dateRangeFilter, customDateRange]);

  const fetchVouchers = async (
    pageNum = 1,
    reset = false,
    filterValues = filters
  ) => {
    const apiFilters = {
      ...filterValues,
      date_range: dateRangeFilter,
      from_date: customDateRange.from,
      to_date: customDateRange.to,
    };

    const data = await GetPaymentVoucherList(apiFilters, pageNum);

    if (reset || pageNum === 1) {
      setPaymentVouchers(
        Array.isArray(data) ? data.results : data.results || []
      );
    } else {
      setPaymentVouchers((prev) => [
        ...prev,
        ...(Array.isArray(data) ? data.results : data.results || []),
      ]);
    }

    setHasMore(Array.isArray(data) ? data.next !== null : data.next !== null);
    setPage(pageNum);
  };

  const fetchMoreData = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchVouchers(nextPage);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const fetchAllData = async () => {
    try {
      const [General, Purchase, bank, expense] = await Promise.all([
        GetApproveGVs(),
        GetApprovedPVs(),
        BankDetailList(),
        ExpenseList(),
      ]);
      setGeneralVoucherData(
        Array.isArray(General) ? General : General?.results || []
      );
      setPurchaseVoucherData(
        Array.isArray(Purchase) ? Purchase : Purchase?.results || []
      );
      setExpenses(Array.isArray(expense) ? expense : expense?.results || []);
      setBankDetails(Array.isArray(bank) ? bank : bank?.results || []);
    } catch (error) {
      console.error("Data fetch error:", error);
      toast.error("Error fetching initial data");
    }
  };

  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  // ===== Form Utilities =====
  function blankRow() {
    return {
      payment_voucher_no: "",
      payment_number: "",
      project: "",
      voucher_type: "",
      journal_voucher: "",
      division: "",
      supplier: "",
      purchase_voucher: "",
      invoice_number: "",
      amount: "",
      attachment: "",
      payment_mode: "Bank", // ✅ Default to Bank
      invoice_date: "",
      description: "",
      narration: "",
      expense: "",
      bank: "", // ✅ Add bank field
    };
  }

  const handleRowChange = (index, e) => {
    const { name, value } = e.target;
    setRows((prev) => {
      const updated = [...prev];
      updated[index][name] = value;
      return updated;
    });
  };

  const addRow = () => setRows([...rows, blankRow()]);
  const removeRow = (index) => setRows(rows.filter((_, i) => i !== index));

  // ===== Modal Handlers =====
  const handleOpen = () => {
    fetchNextPvNo();
    setOpen(true);
  };

  const handleClose = () => {
    setRows([blankRow()]);
    setOpen(false);
  };

  const fetchNextPvNo = async () => {
    const data = await GeneratePaymentVoucherNo();
    if (data && data.payment_voucher_no) {
      setRows((prev) => {
        const updated = [...prev];
        if (updated.length > 0) {
          updated[0] = {
            ...updated[0],
            payment_number: data.payment_voucher_no,
          };
        }
        return updated;
      });
    }
  };

  const handleEditClick = async (id) => {
    const data = await GetPaymentVoucherById(id);
    if (data) {
      setEditFormData(data);
      setEditModalOpen(true);
    }
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleView = (voucher) => {
    setViewData(voucher);
    setViewModalOpen(true);
  };

  const toWords = new ToWords({ localeCode: "en-IN" });

  const userId = Number(localStorage.getItem("user_id"));

  // ===== Submit Handlers =====
  const handleSubmit = async (e) => {
    e.preventDefault();
    const timestamp = Date.now();

    const newData = rows.map((row, i) => ({
      ...row,
      created_by: userId,
      id: timestamp + i,
      payment_mode: "Bank", // ✅ Ensure Bank mode
    }));

    for (const row of newData) {
      try {
        if (!validateForm(row)) return;

        const formData = new FormData();
        formData.append("payment_voucher_no", row.payment_voucher_no || "");
        formData.append("payment_number", row.payment_number || "");
        formData.append("project", row.project || "");
        formData.append("division", row.division || "");
        formData.append("supplier", row.supplier || "");
        formData.append("invoice_date", row.invoice_date || "");
        formData.append("invoice_number", row.invoice_number || "");
        formData.append("journal_voucher", row.journal_voucher || "");
        formData.append("purchase_voucher", row.purchase_voucher || "");
        formData.append("expense", row.expense || "");
        formData.append("amount", row.amount || "");
        formData.append("payment_mode", "Bank");
        formData.append("narration", row.narration || "");
        formData.append("description", row.description || "");
        formData.append("bank", row.bank || ""); // ✅ Add bank
        formData.append("created_by", row.created_by);
        formData.append("voucher_type", row.voucher_type || "");

        if (row.attachment instanceof File) {
          formData.append("attachment", row.attachment);
        }

        await PaymentVoucherCreate(formData);
      } catch (error) {
        console.error("❌ Failed to submit row:", row, error);
      }
    }

    const updatedList = await GetPaymentVoucherList(filters);
    setPaymentVouchers(updatedList);
    toast.success("Bank Voucher(s) added successfully");
    handleClose();
  };

  const handleEditSave = async () => {
    try {
      if (!validateForm(editFormData)) {
        toast.error("Please fill all required fields.");
        return;
      }

      const formData = new FormData();
      formData.append(
        "payment_voucher_no",
        editFormData.payment_voucher_no || ""
      );
      formData.append("payment_number", editFormData.payment_number || "");
      formData.append("project", editFormData.project || "");
      formData.append("division", editFormData.division || "");
      formData.append("supplier", editFormData.supplier || "");
      formData.append("invoice_date", editFormData.invoice_date || "");
      formData.append("invoice_number", editFormData.invoice_number || "");
      formData.append("journal_voucher", editFormData.journal_voucher || "");
      formData.append("purchase_voucher", editFormData.purchase_voucher || "");
      formData.append("expense", editFormData.expense || "");
      formData.append("amount", editFormData.amount || "");
      formData.append("narration", editFormData.narration || "");
      formData.append("description", editFormData.description || "");
      formData.append("bank", editFormData.bank || ""); // ✅ Add bank
      formData.append("payment_mode", "Bank");
      formData.append("voucher_type", editFormData.voucher_type || "");

      if (editFormData.attachment instanceof File) {
        formData.append("attachment", editFormData.attachment);
      }

      const response = await PaymentVoucherUpdate(
        editFormData.payment_voucher_no,
        formData
      );

      setPaymentVouchers(response);
      setEditModalOpen(false);
      toast.success("Updated successfully!");
    } catch (error) {
      console.error("Update error:", error.response?.data || error.message);
      toast.error("Update failed.");
    }
  };

  const handleDelete = async (voucherId) => {
    try {
      await PaymentVoucherDelete(voucherId);
      const updatedList = await GetPaymentVoucherList(filters);
      setPaymentVouchers(updatedList);
      toast.success("Deleted successfully!");
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Delete failed.");
    }
  };

  const handleApprove = async (voucher) => {
    const approvedById = Number(localStorage.getItem("user_id"));
    if (!approvedById) {
      toast.error("Approver ID not found.");
      return;
    }

    try {
      const updated = await ApproveAccountsPaymentVoucher(
        voucher.payment_voucher_no,
        approvedById,
        voucher.status,
        remarkInput
      );

      setPaymentVouchers((prev) =>
        prev.map((item) =>
          item.payment_voucher_no == updated.payment_voucher_no ? updated : item
        )
      );

      toast.success("Payment Voucher approved successfully!");
    } catch (error) {
      console.error("Approval Error:", error);
      toast.error("Failed to approve Payment Voucher.");
    }
  };

  const userRole = localStorage.getItem("role");

  const validateForm = (data) => {
    const errors = {};
    const rowErrs = [];

    if (!data.amount) errors.amount = "Required";

    setFormErrors(errors);
    setRowErrors(rowErrs);

    return (
      Object.keys(errors).length === 0 &&
      rowErrs.every((e) => Object.keys(e).length === 0)
    );
  };

  useEffect(() => {
    document.body.style.overflow = isMobile ? "auto" : "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMobile]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // ⭐ DATE RANGE HELPER FUNCTIONS
  const getDateRangeDisplay = (rangeType) => {
    const now = new Date();
    const fmt = (d) =>
      `${d.getDate().toString().padStart(2, "0")}-${(d.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${d.getFullYear()}`;

    switch (rangeType) {
      case "today":
        return fmt(now);
      case "yesterday":
        const y = new Date(now);
        y.setDate(y.getDate() - 1);
        return fmt(y);
      case "this_week":
        const ws = new Date(now);
        ws.setDate(ws.getDate() - ws.getDay() + 1);
        return `${fmt(ws)} to ${fmt(now)}`;
      case "previous_week":
        const pwe = new Date(now);
        pwe.setDate(pwe.getDate() - pwe.getDay());
        const pws = new Date(pwe);
        pws.setDate(pws.getDate() - 6);
        return `${fmt(pws)} to ${fmt(pwe)}`;
      case "this_month":
        return `${fmt(new Date(now.getFullYear(), now.getMonth(), 1))} to ${fmt(
          now
        )}`;
      default:
        return "";
    }
  };

  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  // ⭐ ADD THESE TWO FUNCTIONS (after formatDateDisplay function, around line ~290)

  // ✅ Apply Custom Date Range
  const handleApplyCustomDateRange = () => {
    if (tempCustomDateRange.from && tempCustomDateRange.to) {
      setCustomDateRange({ ...tempCustomDateRange });
      setDateRangeFilter("custom");
      setDateMenuAnchor(null);
      setShowCustomDateInputs(false);
    } else {
      toast.warning("Please select both From and To dates");
    }
  };

  // ✅ Cancel Custom Date Range
  const handleCancelCustomDateRange = () => {
    setTempCustomDateRange({ from: "", to: "" });
    setShowCustomDateInputs(false);
  };

  return (
    <>
      <ToastContainer />

      {/* ✅ Responsive Filters */}
      <Box
        display="flex"
        flexWrap={{ xs: "wrap", md: "nowrap" }}
        alignItems="center"
        sx={{
          mt: -3,
          pt: -3,
          mb: 1,
          width: "100%",
          gap: 2,
        }}
      >
        {/* Radio Buttons */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexShrink: 0,
            whiteSpace: "nowrap",
            width: { xs: "100%", md: "auto" },
            justifyContent: { xs: "space-around", md: "flex-start" },
          }}
        >
          <input
            type="radio"
            id="pending"
            name="status"
            value="Pending"
            checked={filters.status === "Pending"}
            onChange={handleFilterChange}
            style={{
              marginLeft: "10px",
              width: "10px",
              height: "10px",
              verticalAlign: "middle",
            }}
          />
          <label htmlFor="pending" style={{ fontSize: "12px" }}>
            Pending
          </label>

          <input
            type="radio"
            id="approved"
            name="status"
            value="Approved"
            checked={filters.status === "Approved"}
            onChange={handleFilterChange}
            style={{
              marginLeft: "10px",
              width: "10px",
              height: "10px",
              verticalAlign: "middle",
            }}
          />
          <label htmlFor="approved" style={{ fontSize: "12px" }}>
            Approved
          </label>

          <input
            type="radio"
            id="rejected"
            name="status"
            value="Rejected"
            checked={filters.status === "Rejected"}
            onChange={handleFilterChange}
            style={{
              marginLeft: "10px",
              width: "10px",
              height: "10px",
              verticalAlign: "middle",
            }}
          />
          <label htmlFor="rejected" style={{ fontSize: "12px" }}>
            Rejected
          </label>
        </Box>

        {/* ⭐ DATE RANGE FIELD - ADD THIS */}
        <Box sx={{ width: { xs: "100%", sm: "50%", md: "20%" } }}>
          <TextField
            label="Date Range"
            value={
              dateRangeFilter === "custom" &&
                customDateRange.from &&
                customDateRange.to
                ? `${formatDateDisplay(
                  customDateRange.from
                )} to ${formatDateDisplay(customDateRange.to)}`
                : dateRangeFilter === "today"
                  ? "Today"
                  : dateRangeFilter === "yesterday"
                    ? "Yesterday"
                    : dateRangeFilter === "this_week"
                      ? "This Week"
                      : dateRangeFilter === "previous_week"
                        ? "Previous Week"
                        : dateRangeFilter === "this_month"
                          ? "This Month"
                          : "Select Date Range"
            }
            onClick={(e) => setDateMenuAnchor(e.currentTarget)}
            size="small"
            fullWidth
            InputProps={{
              readOnly: true,
              endAdornment: (
                <IconButton size="small" edge="end">
                  <ArrowDropDownIcon />
                </IconButton>
              ),
            }}
            sx={{
              cursor: "pointer",
              "& .MuiInputBase-input": {
                fontSize: "0.8rem",
                padding: "4px 8px",
              },
              "& .MuiInputBase-root": { height: 30, borderRadius: 0 },
              "& .MuiInputLabel-root": { fontSize: "0.7rem" },
            }}
          />
        </Box>

        {/* Search Fields Container */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flex: 1,
            width: "100%",
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <TextField
            label="Payment Voucher No"
            name="payment_no"
            size="small"
            value={filters.payment_no}
            onChange={handleFilterChange}
            sx={{
              flex: { xs: "none", md: "1 1 150px" },
              width: { xs: "100%", md: "auto" },
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.65rem",
              },
            }}
          />
          <TextField
            label="PO No"
            name="po_no"
            size="small"
            value={filters.po_no}
            onChange={handleFilterChange}
            sx={{
              flex: { xs: "none", md: "1 1 150px" },
              width: { xs: "100%", md: "auto" },
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.65rem",
              },
            }}
          />
          <TextField
            label="Supplier"
            name="supplier"
            size="small"
            value={filters.supplier}
            onChange={handleFilterChange}
            sx={{
              flex: { xs: "none", md: "1 1 150px" },
              width: { xs: "100%", md: "auto" },
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.65rem",
              },
            }}
          />
        </Box>

        {/* ⭐ REPLACE OLD MENU WITH THIS */}
        <Menu
          anchorEl={dateMenuAnchor}
          open={Boolean(dateMenuAnchor)}
          onClose={() => {
            setDateMenuAnchor(null);
            setShowCustomDateInputs(false);
            setTempCustomDateRange({ from: "", to: "" });
          }}
          PaperProps={{
            sx: { width: 350, maxHeight: 500 },
          }}
        >
          {/* Quick Ranges */}
          {[
            { key: "today", label: "Today" },
            { key: "yesterday", label: "Yesterday" },
            { key: "this_week", label: "This Week" },
            { key: "previous_week", label: "Previous Week" },
            { key: "this_month", label: "This Month" },
          ].map((item) => (
            <MenuItem
              key={item.key}
              onClick={() => {
                setDateRangeFilter(item.key);
                setCustomDateRange({ from: "", to: "" });
                setDateMenuAnchor(null);
                setShowCustomDateInputs(false);
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Typography variant="body2">{item.label}</Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: "0.7rem" }}
                >
                  {getDateRangeDisplay(item.key)}
                </Typography>
              </Box>
            </MenuItem>
          ))}

          <Divider />

          {/* ✅ Custom Date Range - Expandable */}
          <MenuItem
            onClick={() => setShowCustomDateInputs((prev) => !prev)}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              bgcolor: showCustomDateInputs ? "#e3f2fd" : "inherit",
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontWeight: showCustomDateInputs ? 600 : 400 }}
            >
              Custom Date Range
            </Typography>
            {showCustomDateInputs ? <ExpandLess /> : <ExpandMore />}
          </MenuItem>

          <Collapse in={showCustomDateInputs} timeout="auto" unmountOnExit>
            <Box
              sx={{
                px: 2,
                py: 2,
                bgcolor: "#f5f5f5",
                borderTop: "1px solid #e0e0e0",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ mb: 1, display: "block" }}
              >
                Select Date Range
              </Typography>

              {/* From and To Date Inputs Side by Side */}
              <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                <TextField
                  label="From Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.from}
                  onChange={(e) =>
                    setTempCustomDateRange((prev) => ({
                      ...prev,
                      from: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    max: tempCustomDateRange.to || undefined,
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": {
                      height: 40,
                      fontSize: "0.75rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  }}
                />

                <TextField
                  label="To Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.to}
                  onChange={(e) =>
                    setTempCustomDateRange((prev) => ({
                      ...prev,
                      to: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    min: tempCustomDateRange.from || undefined,
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": {
                      height: 40,
                      fontSize: "0.75rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  }}
                />
              </Box>

              {/* Selected Range Preview */}
              {tempCustomDateRange.from && tempCustomDateRange.to && (
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    mb: 1.5,
                    p: 1,
                    bgcolor: "#e8f5e9",
                    borderRadius: 1,
                    textAlign: "center",
                    color: "#2e7d32",
                    fontWeight: 500,
                  }}
                >
                  📅 {formatDateDisplay(tempCustomDateRange.from)} to{" "}
                  {formatDateDisplay(tempCustomDateRange.to)}
                </Typography>
              )}

              {/* Apply and Cancel Buttons */}
              <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCancelCustomDateRange}
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleApplyCustomDateRange}
                  disabled={
                    !tempCustomDateRange.from || !tempCustomDateRange.to
                  }
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Apply
                </Button>
              </Box>
            </Box>
          </Collapse>
        </Menu>
      </Box>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "600px",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
            {rows.map((row, index) => (
              <Box
                key={index}
                sx={{
                  mb: 2,
                  backgroundColor: "#f5f7fa",
                  borderRadius: 2,
                  border: "1px solid #e0e0e0",
                  p: 2,
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Voucher No."
                      name="payment_number"
                      value={row.payment_number || ""}
                      size="small"
                      disabled
                      sx={{ width: 500 }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Invoice No."
                      name="invoice_number"
                      value={row.invoice_number || ""}
                      onChange={(e) => handleRowChange(index, e)}
                      size="small"
                      error={!!formErrors.invoice_number}
                      sx={{ width: 500 }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Invoice Date"
                      name="invoice_date"
                      type="date"
                      value={row.invoice_date || ""}
                      onChange={(e) => handleRowChange(index, e)}
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      error={!!formErrors.invoice_date}
                      sx={{ width: 500 }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <FormControl component="fieldset">
                      <FormLabel component="legend">
                        Select Voucher Type
                      </FormLabel>
                      <RadioGroup
                        row
                        value={row.voucher_type || ""}
                        onChange={(e) =>
                          handleRowChange(index, {
                            target: {
                              name: "voucher_type",
                              value: e.target.value,
                            },
                          })
                        }
                      >
                        <FormControlLabel
                          value="journal"
                          control={<Radio />}
                          label="Journal Voucher"
                        />
                        <FormControlLabel
                          value="purchase"
                          control={<Radio />}
                          label="Purchase Voucher"
                        />
                        <FormControlLabel
                          value="expense"
                          control={<Radio />}
                          label="Expense"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  {row.voucher_type === "journal" && (
                    <Grid item xs={12}>
                      <Autocomplete
                        options={generalVoucherData}
                        getOptionLabel={(option) => option.gen_number || ""}
                        value={
                          (Array.isArray(generalVoucherData) &&
                            generalVoucherData.find(
                              (d) => d.gen_voucher_no === row.journal_voucher
                            )) ||
                          null
                        }
                        onChange={(e, newValue) => {
                          handleRowChange(index, {
                            target: {
                              name: "journal_voucher",
                              value: newValue ? newValue.gen_voucher_no : "",
                            },
                          });

                          if (newValue) {
                            handleRowChange(index, {
                              target: {
                                name: "division",
                                value: newValue.division || "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "division_name",
                                value: newValue.division_name || "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "project",
                                value: newValue.project?.id || "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "project_name",
                                value: newValue.project?.project_name || "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "imprest",
                                value: newValue.imprest || "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "imprest_name",
                                value: newValue.imprest_name || "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "expense",
                                value: newValue.expense || "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "expense_name",
                                value: newValue.expense_name || "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "amount",
                                value: newValue.amount.toFixed(2) || "",
                              },
                            });
                          } else {
                            [
                              "division",
                              "division_name",
                              "project",
                              "project_name",
                              "imprest",
                              "expense",
                              "amount",
                            ].forEach((field) =>
                              handleRowChange(index, {
                                target: { name: field, value: "" },
                              })
                            );
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Journal Voucher No"
                            size="small"
                            sx={{ width: 500 }}
                          />
                        )}
                      />
                    </Grid>
                  )}

                  {row.voucher_type === "purchase" && (
                    <Grid item xs={12}>
                      <Autocomplete
                        options={purchaseVoucherData}
                        getOptionLabel={(option) =>
                          option.purchase_number || ""
                        }
                        value={
                          (Array.isArray(purchaseVoucherData) &&
                            purchaseVoucherData.find(
                              (d) =>
                                d.purchase_voucher_no === row.purchase_voucher
                            )) ||
                          null
                        }
                        onChange={(e, newValue) => {
                          handleRowChange(index, {
                            target: {
                              name: "purchase_voucher",
                              value: newValue
                                ? newValue.purchase_voucher_no
                                : "",
                            },
                          });

                          if (newValue) {
                            handleRowChange(index, {
                              target: {
                                name: "division",
                                value: newValue.division || "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "division_name",
                                value: newValue.division_name || "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "project",
                                value: newValue.project || "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "project_name",
                                value: newValue.project_name || "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "supplier",
                                value: newValue.supplier || "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "supplier_name",
                                value: newValue.supplier_name || "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "amount",
                                value: newValue.amount.toFixed(2) || "",
                              },
                            });
                          } else {
                            [
                              "division",
                              "division_name",
                              "project",
                              "project_name",
                              "imprest",
                              "expense",
                              "amount",
                            ].forEach((field) =>
                              handleRowChange(index, {
                                target: { name: field, value: "" },
                              })
                            );
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Purchase Voucher No"
                            size="small"
                            sx={{ width: 500 }}
                          />
                        )}
                      />
                    </Grid>
                  )}

                  {(row.voucher_type === "purchase" ||
                    row.voucher_type === "journal") && (
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Project"
                          name="project_name"
                          size="small"
                          value={row.project_name || ""}
                          disabled
                          sx={{ width: 500 }}
                        />
                      </Grid>
                    )}

                  {(row.voucher_type === "purchase" ||
                    row.voucher_type === "journal") && (
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Division"
                          name="division_name"
                          size="small"
                          value={row.division_name || ""}
                          disabled
                          sx={{ width: 500 }}
                        />
                      </Grid>
                    )}

                  {row.voucher_type === "purchase" && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Supplier"
                        name="supplier_name"
                        size="small"
                        value={row.supplier_name || ""}
                        disabled
                        sx={{ width: 500 }}
                      />
                    </Grid>
                  )}

                  {row.voucher_type === "expense" && (
                    <>
                      <Grid item xs={12}>
                        <Autocomplete
                          options={expenses || []}
                          getOptionLabel={(option) => option.expense || ""}
                          value={
                            expenses?.find(
                              (expense) => expense.expense_id === row.expense
                            ) || null
                          }
                          onChange={(e, newValue) => {
                            handleRowChange(index, {
                              target: {
                                name: "expense",
                                value: newValue ? newValue.expense_id : "",
                              },
                            });
                            handleRowChange(index, {
                              target: {
                                name: "expense_name",
                                value: newValue ? newValue.expense : "",
                              },
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Expense"
                              size="small"
                              sx={{ width: 500 }}
                            />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Amount"
                          name="amount"
                          size="small"
                          type="number"
                          value={row.amount || ""}
                          onChange={(e) => handleRowChange(index, e)}
                          inputProps={{ min: 0, step: 0.01 }}
                          sx={{ width: 500 }}
                        />
                      </Grid>
                    </>
                  )}

                  {row.voucher_type === "journal" && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Imprest Acc"
                        name="imprest"
                        size="small"
                        value={row.imprest_name || ""}
                        disabled
                        sx={{ width: 500 }}
                      />
                    </Grid>
                  )}

                  {row.voucher_type === "journal" && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Expense"
                        name="expense"
                        size="small"
                        value={row.expense_name || ""}
                        disabled
                        sx={{ width: 500 }}
                      />
                    </Grid>
                  )}

                  {(row.voucher_type === "purchase" ||
                    row.voucher_type === "journal") && (
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Amount"
                          name="amount"
                          size="small"
                          value={row.amount || ""}
                          disabled
                          sx={{ width: 500 }}
                        />
                      </Grid>
                    )}

                  {/* ✅ Bank Payment Only */}
                  <Grid item xs={12}>
                    <FormControl component="fieldset">
                      <FormLabel component="legend">
                        Payment Mode: Bank
                      </FormLabel>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <Autocomplete
                      options={bankDetails}
                      getOptionLabel={(option) => option.account_number}
                      value={bankDetails.find(
                        (option) => option.id === row.bank
                      )}
                      onChange={(e, newValue) => {
                        handleRowChange(index, {
                          target: {
                            name: "bank",
                            value: newValue ? newValue.id : null,
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Bank Details"
                          size="small"
                          sx={{ width: 500 }}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Narration"
                      name="narration"
                      value={row.narration || ""}
                      onChange={(e) => handleRowChange(index, e)}
                      size="small"
                      sx={{ width: 500 }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      type="file"
                      name="attachment"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        handleRowChange(index, {
                          target: { name: "attachment", value: file },
                        });
                      }}
                      label="Attachment"
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      sx={{ width: 500 }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    {rows.length > 1 && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <Button
                          variant="outlined"
                          color="error"
                          onClick={() => removeRow(index)}
                          size="small"
                          startIcon={<Close fontSize="small" />}
                          sx={{ textTransform: "none", fontWeight: 500 }}
                        >
                          Remove
                        </Button>
                      </Box>
                    )}
                  </Grid>
                </Grid>
              </Box>
            ))}
          </Box>

          <Box
            sx={{
              borderTop: "1px solid #ddd",
              p: 2,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              backgroundColor: "#fafafa",
              gap: 1,
            }}
          >
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="outlined"
                onClick={handleSubmit}
                size="small"
                sx={{ px: 2, fontWeight: 500 }}
              >
                Submit
              </Button>
              <Button
                variant="contained"
                onClick={handleClose}
                size="small"
                sx={{ px: 2 }}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <InfiniteScroll
        dataLength={PaymentVouchers.length}
        next={fetchMoreData}
        hasMore={hasMore}
        loader={<h4>Loading...</h4>}
      >
        {isMobile ? (
          /* 📱 MOBILE VIEW */
          <Box
            sx={{
              bgcolor: "background.paper",
              maxHeight: "88vh",
              overflow: "auto",
            }}
          >
            {PaymentVouchers.map((voucher, index) => (
              <Box key={voucher.id || index}>
                <Box
                  onClick={() =>
                    setExpandedVoucher(
                      expandedVoucher === voucher.id ? null : voucher.id
                    )
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1.5,
                    cursor: "pointer",
                    bgcolor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                    "&:active": { bgcolor: "#e3f2fd" },
                    borderLeft: `4px solid ${voucher.status === "Approved"
                      ? "#4caf50"
                      : voucher.status === "Rejected"
                        ? "#f44336"
                        : "#ff9800"
                      }`,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 0.5,
                      }}
                    >
                      <Typography
                        sx={{ fontSize: "0.7rem", color: "#666", minWidth: 25 }}
                      >
                        #{index + 1}
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.85rem",
                          flex: 1,
                        }}
                      >
                        {voucher.payment_number}
                      </Typography>
                    </Box>

                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                        color: "#666",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <span style={{ fontWeight: 600, color: "#2e7d32" }}>
                        ₹{voucher.total_amount?.toLocaleString("en-IN")}
                      </span>
                      <span style={{ color: "#999" }}>•</span>
                      <span style={{ fontSize: "0.7rem" }}>
                        {formatDate(voucher.created_at)}
                      </span>
                    </Typography>
                  </Box>

                  <IconButton size="small" sx={{ ml: 1 }}>
                    {expandedVoucher === voucher.id ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </IconButton>
                </Box>

                <Collapse
                  in={expandedVoucher === voucher.id}
                  timeout="auto"
                  unmountOnExit
                >
                  <Box
                    sx={{
                      px: 1.5,
                      py: 1,
                      bgcolor: index % 2 === 0 ? "#f8f9fa" : "#fafafa",
                      borderLeft: `4px solid ${voucher.status === "Approved"
                        ? "#4caf50"
                        : voucher.status === "Rejected"
                          ? "#f44336"
                          : "#ff9800"
                        }`,
                    }}
                  >
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: 0.8,
                        mb: 1,
                      }}
                    >
                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          PROJECT
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight: 500,
                            color: "#333",
                          }}
                        >
                          {voucher.project_name || "N/A"}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          DIVISION
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.division_name || "N/A"}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          PAYMENT MODE
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.payment_mode || "N/A"}
                        </Typography>
                      </Box>

                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          LEDGER NAME
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.supplier_name ||
                            voucher.expense_name ||
                            voucher.advanceworker_name ||
                            voucher.imprest_name ||
                            voucher.party_name ||
                            "N/A"}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          CREATED BY
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.created_by_name || "N/A"}
                        </Typography>
                      </Box>

                      {voucher.approved_name && (
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            APPROVED BY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {voucher.approved_name}
                          </Typography>
                        </Box>
                      )}

                      {voucher.payment_date && (
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            PAYMENT DATE
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {voucher.payment_date}
                          </Typography>
                        </Box>
                      )}
                    </Box>

                    {voucher.remarks && (
                      <Box sx={{ mb: 0.8 }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                            mb: 0.3,
                          }}
                        >
                          REMARKS
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "#555",
                            fontStyle: "italic",
                            lineHeight: 1.3,
                          }}
                        >
                          {voucher.remarks}
                        </Typography>
                      </Box>
                    )}

                    <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      {userRole != "Staff" && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            bgcolor:
                              voucher.status === "Approved"
                                ? "#e8f5e9"
                                : voucher.status === "Rejected"
                                  ? "#ffebee"
                                  : "#fff3e0",
                            px: 1,
                            py: 0.5,
                            borderRadius: "6px",
                            border: `1px solid ${voucher.status === "Approved"
                              ? "#4caf50"
                              : voucher.status === "Rejected"
                                ? "#f44336"
                                : "#ff9800"
                              }`,
                          }}
                        >
                          <Checkbox
                            checked={
                              voucher.status === "Approved" ||
                              voucher.status === "Rejected"
                            }
                            onChange={(e) => {
                              e.stopPropagation();
                              setApproveAnchorEl(e.currentTarget);
                              setPaymentToApprove(voucher);
                            }}
                            sx={{
                              padding: 0,
                              transform: "scale(0.75)",
                              color:
                                voucher.status === "Approved"
                                  ? "#4caf50"
                                  : voucher.status === "Rejected"
                                    ? "#f44336"
                                    : "#ff9800",
                              "&.Mui-checked": {
                                color:
                                  voucher.status === "Approved"
                                    ? "#4caf50"
                                    : "#f44336",
                              },
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              fontWeight: 600,
                              color:
                                voucher.status === "Approved"
                                  ? "#2e7d32"
                                  : voucher.status === "Rejected"
                                    ? "#c62828"
                                    : "#f57c00",
                            }}
                          >
                            {voucher.status === "Approved"
                              ? "Approved"
                              : voucher.status === "Rejected"
                                ? "Rejected"
                                : "Approve"}
                          </Typography>
                        </Box>
                      )}

                      <Box sx={{ display: "flex", gap: 0.6 }}>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            generatePaymentPdf(voucher);
                          }}
                          sx={{
                            bgcolor: "#fff3e0",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": {
                              bgcolor: "#ffe0b2",
                              transform: "scale(1.05)",
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <Print sx={{ fontSize: "1rem", color: "#f57c00" }} />
                        </IconButton>

                        {typeof voucher.attachment === "string" ? (
                          <a
                            href={`${voucher.attachment}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <IconButton
                              size="small"
                              sx={{
                                bgcolor: "#e3f2fd",
                                borderRadius: "6px",
                                width: 32,
                                height: 32,
                                "&:hover": {
                                  bgcolor: "#bbdefb",
                                  transform: "scale(1.05)",
                                },
                                transition: "all 0.2s",
                              }}
                            >
                              <Visibility
                                sx={{ fontSize: "1rem", color: "#1976d2" }}
                              />
                            </IconButton>
                          </a>
                        ) : voucher.attachment instanceof File ? (
                          <a
                            href={URL.createObjectURL(voucher.attachment)}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <IconButton
                              size="small"
                              sx={{
                                bgcolor: "#e3f2fd",
                                borderRadius: "6px",
                                width: 32,
                                height: 32,
                                "&:hover": {
                                  bgcolor: "#bbdefb",
                                  transform: "scale(1.05)",
                                },
                                transition: "all 0.2s",
                              }}
                            >
                              <Visibility
                                sx={{ fontSize: "1rem", color: "#1976d2" }}
                              />
                            </IconButton>
                          </a>
                        ) : null}
                      </Box>
                    </Box>
                  </Box>
                </Collapse>

                <Divider />
              </Box>
            ))}

            <Box
              sx={{
                p: 2,
                bgcolor: "#e3f2fd",
                position: "sticky",
                bottom: 0,
                borderTop: "2px solid #1976d2",
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.85rem",
                  fontWeight: "bold",
                  color: "#1976d2",
                  textAlign: "center",
                }}
              >
                Total Amount: ₹
                {PaymentVouchers.reduce(
                  (sum, v) => sum + parseFloat(v.total_amount || 0),
                  0
                ).toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </Box>
          </Box>
        ) : (
          /* 💻 DESKTOP VIEW */
          <TableContainer
            component={Paper}
            sx={{ maxHeight: "88vh", overflow: "auto" }}
          >
            <Table
              stickyHeader
              size="small"
              sx={{
                minWidth: 1600,
                "& td, & th": {
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  backgroundColor: "#f5f5f5",
                  borderBottom: "1px solid #ccc",
                },
              }}
            >
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "& th": {
                      fontWeight: "bold",
                      color: "#333",
                      borderBottom: "1px solid #999",
                      whiteSpace: "nowrap",
                      fontSize: "0.75rem",
                    },
                  }}
                >
                  {userRole != "Staff" && (
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 0,
                        backgroundColor: "#fafafa",
                        zIndex: 3,
                      }}
                    >
                      Approve
                    </TableCell>
                  )}
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: userRole != "Staff" ? 80 : 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                    }}
                  >
                    S.No.
                  </TableCell>
                  <TableCell>Voucher No</TableCell>
                  <TableCell>Payment Date</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Paid Amt</TableCell>
                  <TableCell>Project</TableCell>
                  <TableCell>Division</TableCell>
                  <TableCell>Ledger Name</TableCell>
                  <TableCell>Payment Mode</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Created By</TableCell>
                  <TableCell>Approved By</TableCell>
                  <TableCell>Remarks</TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {PaymentVouchers.map((voucher, index) => (
                  <TableRow
                    hover
                    key={index}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                      "&:hover": {
                        backgroundColor: "#e3f2fd",
                        "& td": {
                          backgroundColor: "#e3f2fd !important",
                        },
                      },
                      "& td": {
                        paddingRight: "13px !important",
                        paddingLeft: "13px !important",
                        padding: "0px",
                        fontSize: { xs: "0.65rem", sm: "0.75rem" },
                        whiteSpace: "nowrap",
                        color: (theme) =>
                          theme.palette.mode === "dark" ? "white" : "inherit",
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark" ? "black" : "inherit",
                      },
                    }}
                  >
                    {userRole != "Staff" && (
                      <TableCell
                        sx={{
                          position: "sticky",
                          left: 0,
                          backgroundColor: "#fafafa",
                          zIndex: 2,
                        }}
                      >
                        <Checkbox
                          checked={
                            voucher.status === "Approved" ||
                            voucher.status === "Rejected"
                          }
                          onChange={(e) => {
                            setApproveAnchorEl(e.currentTarget);
                            setPaymentToApprove(voucher);
                          }}
                          sx={{
                            padding: 0,
                            paddingLeft: 1,
                            paddingRight: 1,
                            transform: "scale(0.6)",
                            color:
                              voucher.status === "Approved"
                                ? "green"
                                : voucher.status === "Rejected"
                                  ? "red"
                                  : "grey",
                            "&.Mui-checked": {
                              color:
                                voucher.status === "Approved" ? "green" : "red",
                            },
                          }}
                        />
                      </TableCell>
                    )}
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: userRole != "Staff" ? 80 : 0,
                        backgroundColor: "#f5f5f5",
                        zIndex: 2,
                      }}
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell>{voucher.payment_number}</TableCell>
                    <TableCell>{voucher.payment_date}</TableCell>
                    <TableCell align="center">
                      <Chip
                        label={
                          voucher.status === "Approved"
                            ? "Approved"
                            : voucher.status === "Rejected"
                              ? "Rejected"
                              : "Pending"
                        }
                        color={
                          voucher.status === "Approved"
                            ? "success"
                            : voucher.status === "Rejected"
                              ? "error"
                              : "warning"
                        }
                        variant="outlined"
                        size="small"
                        sx={{
                          height: "10px",
                          transform: "scale(0.8)",
                          "& .MuiChip-label": {
                            padding: "0 6px",
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      {voucher.total_amount?.toLocaleString("en-IN")}
                    </TableCell>
                    <TableCell>{voucher.project_name}</TableCell>
                    <TableCell>{voucher.division_name}</TableCell>
                    <TableCell>
                      {voucher.supplier_name ||
                        voucher.expense_name ||
                        voucher.advanceworker_name ||
                        voucher.imprest_name ||
                        voucher.party_name}
                    </TableCell>
                    <TableCell>{voucher.payment_mode}</TableCell>
                    <TableCell>{formatDate(voucher.created_at)}</TableCell>
                    <TableCell>{voucher.created_by_name}</TableCell>
                    <TableCell>{voucher.approved_name}</TableCell>
                    <TableCell>
                      <Tooltip title={voucher.remarks || ""} arrow>
                        <span>{truncateText(voucher.remarks || "", 20)}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell
                      sx={{
                        position: "sticky",
                        right: 0,
                        backgroundColor: "#f5f5f5",
                        minWidth: 180,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: 0.5,
                        }}
                      >
                        <IconButton
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          color="warning"
                          size="small"
                          onClick={() => generatePaymentPdf(voucher)}
                        >
                          <Print transform="scale(0.6)" />
                        </IconButton>
                        <span
                          style={{
                            display: "inline-block",
                            width: 36,
                            textAlign: "center",
                          }}
                        >
                          {typeof voucher.attachment === "string" ? (
                            <a
                              href={`${voucher.attachment}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <IconButton
                                sx={{
                                  padding: 0,
                                  paddingLeft: 1,
                                  paddingRight: 1,
                                }}
                                color="info"
                                size="small"
                              >
                                <Visibility transform="scale(0.6)" />
                              </IconButton>
                            </a>
                          ) : voucher.attachment instanceof File ? (
                            <a
                              href={URL.createObjectURL(voucher.attachment)}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <IconButton
                                sx={{
                                  padding: 0,
                                  paddingLeft: 1,
                                  paddingRight: 1,
                                }}
                                color="info"
                                size="small"
                              >
                                <Visibility fontSize="small" />
                              </IconButton>
                            </a>
                          ) : (
                            <span
                              style={{ display: "inline-block", width: 24 }}
                            />
                          )}
                        </span>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow
                  sx={{ "& td": { backgroundColor: "#E3F2FD !important" } }}
                >
                  <TableCell
                    colSpan={4}
                    align="right"
                    sx={{ fontWeight: "bold !important" }}
                  >
                    Totals:
                  </TableCell>
                  <TableCell>
                    {PaymentVouchers.reduce(
                      (sum, v) => sum + parseFloat(v.total_amount || 0),
                      0
                    ).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </TableCell>
                  <TableCell colSpan={9}></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </InfiniteScroll>

      {/* Rest of the Popovers and Modals remain same... */}

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setVoucherToDelete(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="body2">Are you sure?</Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Button
              color="error"
              size="small"
              onClick={async () => {
                await handleDelete(voucherToDelete);
                setAnchorEl(null);
                setVoucherToDelete(null);
              }}
            >
              Yes
            </Button>
            <Button
              size="small"
              onClick={() => {
                setAnchorEl(null);
                setVoucherToDelete(null);
              }}
            >
              No
            </Button>
          </Box>
        </Box>
      </Popover>

      <Dialog
        open={Boolean(approveAnchorEl)}
        onClose={() => {
          if (openConfirmDialog) return;
          setApproveAnchorEl(null);
          setPaymentToApprove(null);
        }}
        maxWidth={false}
        PaperProps={{
          sx: {
            // Desktop - unchanged
            width: { xs: "calc(100% - 32px)", md: 1050 },
            maxWidth: { xs: "100%", md: 1050 },
            bgcolor: "#fff",

            // Mobile centering
            m: { xs: 2, md: 4 },
            maxHeight: { xs: "calc(100% - 32px)", md: "90vh" },
            borderRadius: { xs: "12px", md: "4px" },



            // Mobile center positioning
            m: { xs: 2, md: 4 },
            maxHeight: { xs: "calc(100% - 32px)", md: "90vh" },
            borderRadius: { xs: "12px", md: "8px" },
          },
        }}
      >
        <DialogContent sx={{ p: { xs: 1.5, sm: 2 }, minWidth: { xs: "auto", sm: 400 } }}>

          {/* ========== MOBILE VIEW ========== */}
          <Box sx={{ display: { xs: "block", md: "none" } }}>

            {/* ===== PAYMENT VOUCHER - Mobile ===== */}
            <Box
              sx={{
                bgcolor: "#fff",
                borderRadius: 2,
                overflow: "hidden",
                mb: 2,
                border: "1px solid #e0e0e0",
              }}
            >
              <Box
                sx={{
                  bgcolor: "#d9d8d8ff",
                  p: 1.5,
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                PAYMENT VOUCHER
              </Box>

              <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 1.5 }}>
                {/* Row 1 */}
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                      Voucher No.
                    </Typography>
                    <Typography variant="body2" fontWeight={600}>
                      {PaymentToApprove?.payment_number || "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1, textAlign: "right" }}>
                    <Typography variant="caption" color="text.secondary">
                      Division
                    </Typography>
                    <Typography variant="body2" fontWeight={600}>
                      {PaymentToApprove?.division_name || "-"}
                    </Typography>
                  </Box>
                </Box>

                <Divider />

                {/* Row 2 */}
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                      Created Date
                    </Typography>
                    <Typography variant="body2" fontWeight={600}>
                      {formatDate(PaymentToApprove?.created_at) || "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1, textAlign: "right" }}>
                    <Typography variant="caption" color="text.secondary">
                      Advance Amount
                    </Typography>
                    <Typography variant="body2" fontWeight={600} color="primary">
                      ₹ {PaymentToApprove?.total_amount || "-"}
                    </Typography>
                  </Box>
                </Box>

                <Divider />

                {/* Row 3 */}
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Project
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ wordBreak: "break-word" }}>
                    {PaymentToApprove?.party_name ||
                      PaymentToApprove?.imprest_name ||
                      PaymentToApprove?.supplier_name ||
                      PaymentToApprove?.account_name ||
                      PaymentToApprove?.expense_name ||
                      PaymentToApprove?.advanceworker_name ||
                      PaymentToApprove?.transporter_name ||
                      "-"}
                  </Typography>
                </Box>

                <Divider />

                {/* Row 4 */}
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Ledger Name
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ wordBreak: "break-word" }}>
                    {PaymentToApprove?.party_name ||
                      PaymentToApprove?.imprest_name ||
                      PaymentToApprove?.supplier_name ||
                      PaymentToApprove?.account_name ||
                      PaymentToApprove?.expense_name ||
                      PaymentToApprove?.advanceworker_name ||
                      PaymentToApprove?.transporter_name ||
                      "-"}
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* ===== AGAINST REFERENCE - Mobile ===== */}
            {PaymentToApprove?.method_of_payment === "against_reference" && (
              <Box
                sx={{
                  bgcolor: "#fff",
                  borderRadius: 2,
                  overflow: "hidden",
                  mb: 2,
                  border: "1px solid #e0e0e0",
                }}
              >
                <Box
                  sx={{
                    bgcolor: "#d9d8d8ff",
                    p: 1.5,
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  AGAINST REFERENCE
                </Box>

                <Box sx={{ p: 1.5 }}>
                  {PaymentToApprove?.payment_subvoucher?.length > 0 ? (
                    <>
                      {PaymentToApprove.payment_subvoucher.map((item, index) => (
                        <Box
                          key={item.id || index}
                          sx={{
                            bgcolor: "#f9f9f9",
                            borderRadius: 1,
                            p: 1.5,
                            mb: 1,
                            border: "1px solid #e5e7eb",
                          }}
                        >
                          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                            <Typography variant="body2" fontWeight={600}>
                              #{index + 1} - {item.journal_voucher_no || "-"}
                            </Typography>
                            <Typography variant="body2" fontWeight={700} color="primary">
                              ₹ {parseFloat(item.paid_amount || 0).toFixed(2)}
                            </Typography>
                          </Box>
                          <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1 }}>
                            <Box>
                              <Typography variant="caption" color="text.secondary">
                                Total Amt
                              </Typography>
                              <Typography variant="body2">
                                ₹ {parseFloat(item.journal_total_amount || 0).toFixed(2)}
                              </Typography>
                            </Box>
                            <Box>
                              <Typography variant="caption" color="text.secondary">
                                Rem Amt
                              </Typography>
                              <Typography variant="body2">
                                ₹ {parseFloat(item.journal_rem_amount || 0).toFixed(2)}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      ))}

                      {/* Total */}
                      <Box
                        sx={{
                          bgcolor: "#e3f2fd",
                          borderRadius: 1,
                          p: 1.5,
                          mt: 1,
                        }}
                      >
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                          <Typography variant="body2" fontWeight={600}>
                            Total
                          </Typography>
                          <Typography variant="body1" fontWeight={700} color="primary">
                            ₹ {PaymentToApprove.payment_subvoucher
                              .reduce((sum, item) => sum + parseFloat(item.paid_amount || 0), 0)
                              .toFixed(2)}
                          </Typography>
                        </Box>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{ mt: 1, display: "block", fontStyle: "italic" }}
                        >
                          (In Words): {toWords.convert(
                            PaymentToApprove.payment_subvoucher.reduce(
                              (sum, item) => sum + parseFloat(item.paid_amount || 0),
                              0
                            )
                          )}
                        </Typography>
                      </Box>
                    </>
                  ) : (
                    <Box sx={{ textAlign: "center", py: 2 }}>
                      <Typography variant="body2" color="text.secondary">
                        No references found
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            )}

            {/* ===== PAYMENT MODE - Mobile ===== */}
            <Box
              sx={{
                bgcolor: "#fff",
                borderRadius: 2,
                overflow: "hidden",
                border: "1px solid #e0e0e0",
              }}
            >
              <Box
                sx={{
                  bgcolor: "#d9d8d8ff",
                  p: 1.5,
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                PAYMENT MODE
              </Box>

              <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 1.5 }}>
                {/* Row 1 */}
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                      Payment Mode
                    </Typography>
                    <Typography variant="body2" fontWeight={600}>
                      {PaymentToApprove?.payment_mode || "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1, textAlign: "right" }}>
                    <Typography variant="caption" color="text.secondary">
                      Payment Date
                    </Typography>
                    <Typography variant="body2" fontWeight={600}>
                      {formatDate(PaymentToApprove?.payment_date) || "-"}
                    </Typography>
                  </Box>
                </Box>

                <Divider />

                {/* Row 2 */}
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                      Cheque No
                    </Typography>
                    <Typography variant="body2" fontWeight={600}>
                      {PaymentToApprove?.description || "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1, textAlign: "right" }}>
                    <Typography variant="caption" color="text.secondary">
                      Cheque Date
                    </Typography>
                    <Typography variant="body2" fontWeight={600}>
                      {PaymentToApprove?.cheque_date || "-"}
                    </Typography>
                  </Box>
                </Box>

                <Divider />

                {/* Row 3 */}
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Account No
                  </Typography>
                  <Typography variant="body2" fontWeight={600}>
                    {PaymentToApprove?.account_number || "-"}
                  </Typography>
                </Box>

                <Divider />

                {/* Row 4 */}
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Narration
                  </Typography>
                  <Typography variant="body2" sx={{ wordBreak: "break-word" }}>
                    {PaymentToApprove?.narration || "-"}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>

          {/* ========== DESKTOP VIEW - UNCHANGED ========== */}
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            {/* ===== PAYMENT VOUCHER ===== */}
            <TableContainer component={Paper} sx={{ borderRadius: 0 }}>
              <Table size="small" sx={{ bgcolor: "#fff" }}>
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={4}
                      align="center"
                      sx={{ fontWeight: "bold", bgcolor: "#d9d8d8ff" }}
                    >
                      PAYMENT VOUCHER
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>
                      <b>Voucher No.</b>
                    </TableCell>
                    <TableCell>{PaymentToApprove?.payment_number}</TableCell>
                    <TableCell>
                      <b>Division</b>
                    </TableCell>
                    <TableCell>{PaymentToApprove?.division_name}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>
                      <b>Created Date</b>
                    </TableCell>
                    <TableCell>
                      {formatDate(PaymentToApprove?.created_at)}
                    </TableCell>
                    <TableCell>
                      <b>Ledger Name</b>
                    </TableCell>
                    <TableCell>
                      {PaymentToApprove?.party_name ||
                        PaymentToApprove?.imprest_name ||
                        PaymentToApprove?.supplier_name ||
                        PaymentToApprove?.account_name ||
                        PaymentToApprove?.expense_name ||
                        PaymentToApprove?.advanceworker_name ||
                        PaymentToApprove?.transporter_name ||
                        "-"}
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>
                      <b>Project</b>
                    </TableCell>
                    <TableCell>
                      {PaymentToApprove?.party_name ||
                        PaymentToApprove?.imprest_name ||
                        PaymentToApprove?.supplier_name ||
                        PaymentToApprove?.account_name ||
                        PaymentToApprove?.expense_name ||
                        PaymentToApprove?.advanceworker_name ||
                        PaymentToApprove?.transporter_name ||
                        "-"}
                    </TableCell>
                    <TableCell>
                      <b>Advance Amount</b>
                    </TableCell>
                    <TableCell>₹ {PaymentToApprove?.total_amount}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

            {/* ===== AGAINST REFERENCE ===== */}
            {PaymentToApprove?.method_of_payment === "against_reference" && (
              <TableContainer component={Paper} sx={{ mt: 2, borderRadius: 0 }}>
                <Table size="small" sx={{ bgcolor: "#fff" }}>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        colSpan={5}
                        align="center"
                        sx={{
                          fontWeight: "bold",
                          border: "1px solid #000",
                          bgcolor: "#d9d8d8ff",
                        }}
                      >
                        AGAINST REFERENCE
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      {["S.No", "Voucher No", "Total Amt", "Rem Amt", "Total Pay Amt"].map((head) => (
                        <TableCell
                          key={head}
                          align="center"
                          sx={{ fontWeight: "bold", border: "1px solid #000" }}
                        >
                          {head}
                        </TableCell>
                      ))}
                    </TableRow>

                    {PaymentToApprove?.payment_subvoucher?.length > 0 ? (
                      PaymentToApprove.payment_subvoucher.map((item, index) => (
                        <TableRow key={item.id || index}>
                          <TableCell align="center" sx={{ border: "1px solid #000" }}>
                            {index + 1}
                          </TableCell>
                          <TableCell sx={{ border: "1px solid #000" }}>
                            {item.journal_voucher_no || "-"}
                          </TableCell>
                          <TableCell align="right" sx={{ border: "1px solid #000" }}>
                            {parseFloat(item.journal_total_amount || 0).toFixed(2)}
                          </TableCell>
                          <TableCell align="right" sx={{ border: "1px solid #000" }}>
                            {parseFloat(item.journal_rem_amount || 0).toFixed(2)}
                          </TableCell>
                          <TableCell align="right" sx={{ border: "1px solid #000" }}>
                            {parseFloat(item.paid_amount || 0).toFixed(2)}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={5} align="center" sx={{ border: "1px solid #000", py: 2 }}>
                          No references found
                        </TableCell>
                      </TableRow>
                    )}

                    {PaymentToApprove?.payment_subvoucher?.length > 0 && (
                      <TableRow>
                        <TableCell colSpan={4} align="right" sx={{ fontWeight: "bold", border: "1px solid #000" }}>
                          Total
                        </TableCell>
                        <TableCell align="right" sx={{ fontWeight: "bold", border: "1px solid #000" }}>
                          {PaymentToApprove.payment_subvoucher
                            .reduce((sum, item) => sum + parseFloat(item.paid_amount || 0), 0)
                            .toFixed(2)}
                        </TableCell>
                      </TableRow>
                    )}

                    {PaymentToApprove?.payment_subvoucher?.length > 0 && (
                      <TableRow>
                        <TableCell colSpan={5} sx={{ fontStyle: "italic", border: "1px solid #000" }}>
                          (In Words): {toWords.convert(
                            PaymentToApprove.payment_subvoucher.reduce(
                              (sum, item) => sum + parseFloat(item.paid_amount || 0),
                              0
                            )
                          )}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            {/* ===== PAYMENT MODE ===== */}
            <TableContainer component={Paper} sx={{ mt: 2, borderRadius: 0 }}>
              <Table size="small" sx={{ bgcolor: "#fff" }}>
                <TableBody>
                  <TableRow sx={{ bgcolor: "#d9d8d8ff" }}>
                    <TableCell colSpan={6} align="center" sx={{ fontWeight: "bold" }}>
                      PAYMENT MODE
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell><b>Payment Mode</b></TableCell>
                    <TableCell>{PaymentToApprove?.payment_mode}</TableCell>
                    <TableCell><b>Payment Date</b></TableCell>
                    <TableCell>{formatDate(PaymentToApprove?.payment_date)}</TableCell>
                    <TableCell><b>Cheque No</b></TableCell>
                    <TableCell>{PaymentToApprove?.description}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell><b>Cheque Date</b></TableCell>
                    <TableCell>{PaymentToApprove?.cheque_date}</TableCell>
                    <TableCell><b>Account No</b></TableCell>
                    <TableCell colSpan={1}>{PaymentToApprove?.account_number}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell><b>Narration</b></TableCell>
                    <TableCell colSpan={5}>{PaymentToApprove?.narration}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            p: { xs: 1.5, sm: 2 },
            flexWrap: "wrap",
            justifyContent: { xs: "center", md: "flex-end" },
            gap: 1,
          }}
        >
          <Button
            variant="contained"
            color="success"
            size="small"
            sx={{
              minWidth: { xs: "70px", sm: "80px" },
              fontSize: { xs: "12px", sm: "14px" },
            }}
            onClick={() => {
              setActionType("Approved");
              setOpenConfirmDialog(true);
            }}
            disabled={PaymentToApprove?.status === "Approved"}
          >
            Approve
          </Button>

          <Button
            variant="contained"
            size="small"
            sx={{
              minWidth: { xs: "70px", sm: "80px" },
              fontSize: { xs: "12px", sm: "14px" },
              bgcolor: "orange",
              "&:hover": { bgcolor: "#e69500" },
            }}
            onClick={() => {
              setActionType("Rejected");
              setOpenConfirmDialog(true);
            }}
            disabled={PaymentToApprove?.status === "Approved"}
          >
            Reject
          </Button>

          <Button
            variant="outlined"
            color="primary"
            size="small"
            sx={{
              minWidth: { xs: "70px", sm: "80px" },
              fontSize: { xs: "12px", sm: "14px" },
            }}
            disabled={PaymentToApprove?.status === "Approved"}
          >
            Edit
          </Button>

          <Button
            variant="outlined"
            color="error"
            size="small"
            sx={{
              minWidth: { xs: "70px", sm: "80px" },
              fontSize: { xs: "12px", sm: "14px" },
            }}
            onClick={() => {
              setApproveAnchorEl(null);
              setPaymentToApprove(null);
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openConfirmDialog}
        maxWidth="xs"
        onClose={() => {
          setOpenConfirmDialog(false);
          setRemarkInput("");
          setActionType(null);
        }}
      >
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 1 }}>
            Please enter remark before{" "}
            {actionType === "Approved" ? "approving" : "rejecting"}:
          </Typography>

          <TextField
            fullWidth
            size="small"
            value={remarkInput}
            onChange={(e) => setRemarkInput(e.target.value)}
            placeholder="Enter remark"
          />
        </DialogContent>

        <DialogActions>
          <Button
            size="small"
            onClick={() => {
              setOpenConfirmDialog(false);
              setRemarkInput("");
              setActionType(null);
            }}
          >
            Cancel
          </Button>

          <Button
            size="small"
            color={actionType === "Approved" ? "success" : "error"}
            onClick={() => {
              if (!remarkInput.trim()) {
                toast.error("Remark is required!");
                return;
              }

              handleApprove({
                ...PaymentToApprove,
                status: actionType,
                remarks: remarkInput,
              });

              setOpenConfirmDialog(false);
              setApproveAnchorEl(null);
              setPaymentToApprove(null);
              setRemarkInput("");
              setActionType(null);
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Modal */}
      <Modal open={editModalOpen} onClose={() => setEditModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "600px",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ p: 2, borderBottom: "1px solid #ddd" }}>
            <Typography variant="h6" component="h2">
              Edit Bank Payment
            </Typography>
          </Box>
          <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
            <Box
              sx={{
                mb: 2,
                backgroundColor: "#f5f7fa",
                borderRadius: 2,
                border: "1px solid #e0e0e0",
                p: 2,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Voucher No."
                    name="payment_number"
                    value={editFormData.payment_number || ""}
                    size="small"
                    disabled
                    sx={{ width: 500 }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Invoice No."
                    name="invoice_number"
                    value={editFormData.invoice_number || ""}
                    onChange={handleEditChange}
                    size="small"
                    sx={{ width: 500 }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Invoice Date"
                    name="invoice_date"
                    type="date"
                    value={editFormData.invoice_date || ""}
                    onChange={handleEditChange}
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    sx={{ width: 500 }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      Select Voucher Type
                    </FormLabel>
                    <RadioGroup
                      row
                      value={editFormData.voucher_type || ""}
                      onChange={(e) =>
                        setEditFormData((prev) => ({
                          ...prev,
                          voucher_type: e.target.value,
                        }))
                      }
                    >
                      <FormControlLabel
                        value="journal"
                        control={<Radio />}
                        label="Journal Voucher"
                      />
                      <FormControlLabel
                        value="purchase"
                        control={<Radio />}
                        label="Purchase Voucher"
                      />
                      <FormControlLabel
                        value="expense"
                        control={<Radio />}
                        label="Expense"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                {/* Conditional fields same as in create form */}
                {editFormData.voucher_type === "journal" && (
                  <Grid item xs={12}>
                    <Autocomplete
                      options={generalVoucherData}
                      getOptionLabel={(option) => option.gen_voucher_no || ""}
                      value={
                        (Array.isArray(generalVoucherData) &&
                          generalVoucherData.find(
                            (d) =>
                              d.gen_voucher_no === editFormData.journal_voucher
                          )) ||
                        null
                      }
                      onChange={(e, newValue) => {
                        if (newValue) {
                          setEditFormData((prev) => ({
                            ...prev,
                            journal_voucher: newValue.gen_voucher_no || "",
                            division: newValue.division || "",
                            division_name: newValue.division_name || "",
                            project: newValue.project?.id || "",
                            project_name: newValue.project?.project_name || "",
                            imprest: newValue.imprest || "",
                            expense: newValue.expense || "",
                            amount: newValue.amount?.toFixed(2) || "",
                          }));
                        } else {
                          setEditFormData((prev) => ({
                            ...prev,
                            journal_voucher: "",
                            division: "",
                            division_name: "",
                            project: "",
                            project_name: "",
                            imprest: "",
                            expense: "",
                            amount: "",
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Journal Voucher No"
                          size="small"
                          sx={{ width: 500 }}
                        />
                      )}
                    />
                  </Grid>
                )}

                {editFormData.voucher_type === "purchase" && (
                  <Grid item xs={12}>
                    <Autocomplete
                      options={purchaseVoucherData}
                      getOptionLabel={(option) =>
                        option.purchase_voucher_no || ""
                      }
                      value={
                        (Array.isArray(purchaseVoucherData) &&
                          purchaseVoucherData.find(
                            (d) =>
                              d.purchase_voucher_no ===
                              editFormData.purchase_voucher
                          )) ||
                        null
                      }
                      onChange={(e, newValue) => {
                        if (newValue) {
                          setEditFormData((prev) => ({
                            ...prev,
                            purchase_voucher:
                              newValue.purchase_voucher_no || "",
                            division: newValue.division || "",
                            division_name: newValue.division_name || "",
                            project: newValue.project || "",
                            project_name: newValue.project_name || "",
                            supplier: newValue.supplier || "",
                            supplier_name: newValue.supplier_name || "",
                            amount: newValue.amount?.toFixed(2) || "",
                          }));
                        } else {
                          setEditFormData((prev) => ({
                            ...prev,
                            purchase_voucher: "",
                            division: "",
                            division_name: "",
                            project: "",
                            project_name: "",
                            supplier: "",
                            supplier_name: "",
                            amount: "",
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Purchase Voucher No"
                          size="small"
                          sx={{ width: 500 }}
                        />
                      )}
                    />
                  </Grid>
                )}

                {(editFormData.voucher_type === "purchase" ||
                  editFormData.voucher_type === "journal") && (
                    <>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Project"
                          name="project_name"
                          size="small"
                          value={editFormData.project_name || ""}
                          disabled
                          sx={{ width: 500 }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Division"
                          name="division_name"
                          size="small"
                          value={editFormData.division_name || ""}
                          disabled
                          sx={{ width: 500 }}
                        />
                      </Grid>
                    </>
                  )}

                {editFormData.voucher_type === "purchase" && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Supplier"
                      name="supplier_name"
                      size="small"
                      value={editFormData.supplier_name || ""}
                      disabled
                      sx={{ width: 500 }}
                    />
                  </Grid>
                )}

                {editFormData.voucher_type === "expense" && (
                  <>
                    <Grid item xs={12}>
                      <Autocomplete
                        options={expenses || []}
                        getOptionLabel={(option) => option.expense || ""}
                        value={
                          expenses?.find(
                            (expense) =>
                              expense.expense_id === editFormData.expense
                          ) || null
                        }
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setEditFormData((prev) => ({
                              ...prev,
                              expense: newValue.expense_id || "",
                              expense_name: newValue.expense || "",
                            }));
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Expense"
                            size="small"
                            sx={{ width: 500 }}
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Amount"
                        name="amount"
                        size="small"
                        type="number"
                        value={editFormData.amount || ""}
                        onChange={handleEditChange}
                        inputProps={{ min: 0, step: 0.01 }}
                        sx={{ width: 500 }}
                      />
                    </Grid>
                  </>
                )}

                {editFormData.voucher_type === "journal" && (
                  <>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Imprest Acc"
                        name="imprest"
                        size="small"
                        value={editFormData.imprest || ""}
                        disabled
                        sx={{ width: 500 }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Expense"
                        name="expense"
                        size="small"
                        value={editFormData.expense || ""}
                        disabled
                        sx={{ width: 500 }}
                      />
                    </Grid>
                  </>
                )}

                {/* ✅ Bank Payment Only */}
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">Payment Mode: Bank</FormLabel>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <Autocomplete
                    options={bankDetails}
                    getOptionLabel={(option) => option.account_number}
                    value={bankDetails.find(
                      (option) => option.id === editFormData.bank
                    )}
                    onChange={(e, newValue) => {
                      setEditFormData((prev) => ({
                        ...prev,
                        bank: newValue ? newValue.id : null,
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Bank Details"
                        size="small"
                        sx={{ width: 500 }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Narration"
                    name="narration"
                    value={editFormData.narration || ""}
                    onChange={handleEditChange}
                    size="small"
                    sx={{ width: 500 }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    type="file"
                    name="attachment"
                    onChange={handleEditChange}
                    label="Attachment"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    sx={{ width: 500 }}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>

          <Box
            sx={{
              borderTop: "1px solid #ddd",
              p: 2,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              backgroundColor: "#fafafa",
              gap: 1,
            }}
          >
            <Button
              variant="outlined"
              color="error"
              onClick={() => setEditModalOpen(false)}
              size="small"
              sx={{ px: 2 }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleEditSave}
              size="small"
              sx={{ px: 2 }}
            >
              Update
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* View Modal */}
      <Modal open={viewModalOpen} onClose={() => setViewModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "95%",
            maxWidth: "1000px",
            bgcolor: "background.paper",
            borderRadius: 1,
            boxShadow: 24,
            p: 3,
            overflowY: "auto",
            maxHeight: "90vh",
          }}
        >
          <h2>View Payment Voucher</h2>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
            {Object.entries(viewData).map(([key, value]) => (
              <TextField
                key={key}
                label={key.replace(/_/g, " ").toUpperCase()}
                value={value}
                fullWidth
                InputProps={{ readOnly: true }}
                size="small"
                sx={{ flex: 1, minWidth: 180 }}
                margin="dense"
              />
            ))}
          </Box>

          <Box sx={{ textAlign: "right", mt: 2 }}>
            <Button
              onClick={() => setViewModalOpen(false)}
              color="primary"
              variant="contained"
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default PaymentVouchersBank;
